import { cn } from '@/common/utils/cn'

type Props = {
  companyName?: string
  forwardingType: string
  transportType?: string
  sealed?: boolean
  className?: string
}

const CardLabel = ({ companyName, forwardingType, transportType, sealed, className }: Props) => {
  const auctionState = sealed === undefined ? undefined : `Leilão ${sealed ? 'Fechado' : 'Aberto'}`

  return (
    <div className={cn('flex items-center gap-1.5 min-w-0', className)}>
      <span
        className="text-[10px] italic leading-tight truncate"
        title={[forwardingType, transportType, auctionState, companyName].filter(Boolean).join(' • ')}
      >
        <span className="text-white-300">{forwardingType}</span>
        {transportType && <span className="text-white-300"> • {transportType}</span>}
        {auctionState && <span className="text-white-300"> • {auctionState}</span>}
        {companyName && <span className="text-white-400"> • {companyName}</span>}
      </span>
    </div>
  )
}

export default CardLabel
